module.exports = __webpack_public_path__ + "components/flag/static/square/cu-0a202cec924527af782dc8af1ba91ada.svg";